import { configureStore } from "@reduxjs/toolkit";
import appreduxReducer from './slice'

export const store = configureStore({
    reducer:{
        appredux:appreduxReducer
    }
})